import * as React from 'react'
import cx from 'classnames'

import { i18n } from 'app-core'

const SimpleError = ({ className, message }) => (
  <div
    className={cx('alert alert-danger text-center', className)}
    role='alert'
  >{i18n.t(message)}</div>
)

export default SimpleError
